import { useParams } from 'react-router-dom';
import SpoolWidget from './SpoolWidget';

export type WidgetsParams = {
    spoolWidget: string;
    spoolAddress: string;
    spoolWidgetStyling: string | undefined;
};

const Widgets: React.FC = () => {
    const { spoolWidget, spoolAddress } = useParams<WidgetsParams>();

    const ethereumSpoolAddresses = spoolAddress
        ?.replace('&', '')
        .split('spoolAddress=')
        .slice(1);

    return (
        <div className='widgets'>
            {spoolWidget === 'spool-widget' &&
                ethereumSpoolAddresses?.map((address, index) => (
                    <SpoolWidget key={index} address={address} />
                ))}
        </div>
    );
};

export default Widgets;
